// import * as htmlToImage from 'html-to-image';

export const removeQuotes = text => text.replace(/['"]+/g, '');

export const getLastSegmentFromPath = path => path.split('/').pop();

// Converts a file to a Base64 string
export const convertBase64 = async file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
        const remainder = encoded.length % 4;
        if (remainder) {
            encoded += '='.repeat(4 - remainder);
        }
        resolve(encoded);
    };
    reader.onerror = error => reject(error);
});

const randomNumberGenerator = a => a ? (a ^ Math.random() * 16 >> a / 4).toString(16) :
    ([1e16] + 1e16).replace(/[01]/g, randomNumberGenerator);

const getCsrfTokenValue = () => {
    const token = `CS${randomNumberGenerator()}`;
    document.cookie = `X-CSRF-TOKEN=${token}; secure; path=/`;
    return token;
};

const apiCall = async (method, url, data, extraHeader) => {
    const options = {
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'X-CSRF-TOKEN': getCsrfTokenValue()
        }
    };
    if (extraHeader) {
        options.headers = { ...options.headers, ...extraHeader };
    }
    if (data) {
        options.body = JSON.stringify(data);
    }
    try {
        const response = await fetch(url, options);
        const text = await response.text();
        try {
            return text ? JSON.parse(text) : null;
        }
        catch {
            // If not valid JSON, return the response which is most likely pure text
            return text;
        }
    }
    catch (err) {
        console.error('Error communicating with API', err, url, data);
        return null;
    }
};

export const apiPost = async (url, data) => await apiCall('POST', url, data);

export const apiGet = async (url, extraHeader) => await apiCall('GET', url, null, extraHeader);

export const apiPatch = async url => await apiCall('PATCH', url);

export const apiPut = async (url, data) => await apiCall('PUT', url, data);

export const apiDelete = async url => {
    const options = {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'X-CSRF-TOKEN': getCsrfTokenValue()
        }
    };
    try {
        const response = await fetch(url, options);
        return response.status;
    }
    catch (err) {
        console.error('Error communicating with API', err, url);
        return null;
    }
};

/**
 * @param domElement - The dom element which will have its content exported as an image
 * @returns a string representing the image for the given dom element
 * For testing, use https://base64.guru/converter/decode/image/jpg to convert the string back to JPG
 */
// export const pageContentAsImage = async domElement => {
//     try {
//         // Simple workaround to prevent black background in image because of transparent bg
//         domElement.style['background-color'] = 'white';
//         return await htmlToImage.toJpeg(domElement);
//     } catch (e) {
//         console.error(e);
//         return null;
//     }
// };

export const apiUploadFile = async (url, file) => {
    const content = new FormData();
    content.append('file', file);
    const options = {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': getCsrfTokenValue()
        },
        body: content
    };

    try {
        const response = await fetch(url, options);
        return await response.text();
    }
    catch (err) {
        console.error('Error communicating with API', err, url);
        return null;
    }
};